<template>
  <MessageLayout
    image="./aws-token-expired.svg"
    title="Trial license not found"
  >
    Trial license not found. Please check the link or token and try again.
  </MessageLayout>
</template>

<script setup lang="ts">
import MessageLayout from "@/modules/messages/MessageLayout.vue";
</script>
